import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { PayPalButton } from 'react-paypal-button-v2';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core/';
import ErrorMessage from '../Components/Message/errorMessage';
import Message from '../Components/InfoMessage/Message';
import Loader from '../Components/Loader/Loader';
import { getOrder, approveOrder, cancelOrder, payOrder, deliverOrder } from '../Actions/orderAction';
import {  ORDER_DELIVER_RESET, ORDER_APPROVED_RESET, ORDER_CANCELLED_RESET, ORDER_PAID_RESET } from '../Constants/orderConstants';
import { interpolate } from '../utils/string';
// import config from '../config';
import * as routes from '../Constants/routes';
import OrderLoader from '../Components/Loader/OrderLoader';
// import { shipping } from 'Actions/shippingAction';

const Order = ({ match }) => {
  const orderId = match.params.orderId;

  //const [sdkReady, setSdkReady] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const dispatch = useDispatch();

  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error, success } = orderDetails;

  /* const orderPay = useSelector((state) => state.orderPay);
  const {  success: successPayMessage } = orderPay; */
  const orderApprove = useSelector((state) => state.orderApprove);
  const { loading: loadingApprove, success: successApprove } = orderApprove;

  const orderCancel = useSelector((state) => state.orderCancel);
  const { loading: loadingCancel, success: successCancel } = orderCancel;

  const orderPay = useSelector((state) => state.orderPay);
  const { loading: loadingPay, success: successPay } = orderPay;

  const orderDeliver = useSelector((state) => state.orderDeliver);
  const { loading: loadingDeliver, success: successDeliver } = orderDeliver;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const queryParams = new URLSearchParams(window.location.search);

  

  const refId = queryParams.get('refId') ? queryParams.get('refId').trim() : null;

  useEffect(() => {
    /* const addPayPalScript = async () => {
      const { data: clientId } = await axios.get('/api/config/paypal');
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}`;
      script.async = true;
      script.onload = () => {
        setSdkReady(true);
      };
      document.body.appendChild(script);
    }; */

    /* if (order && !order.isPaid) {
      if (!window.paypal) {
        addPayPalScript();
      } else {
        setSdkReady(true);
      }
    } */
    // eslint-disable-next-line
  }, [dispatch, orderId, successPay,,  successDeliver, successApprove, successCancel, order]);

  useEffect(() => {
    dispatch({ type: ORDER_APPROVED_RESET });
    dispatch({ type: ORDER_CANCELLED_RESET });
   dispatch({ type: ORDER_PAID_RESET });
    dispatch({ type: ORDER_DELIVER_RESET });
    dispatch(getOrder(orderId, initialLoading));

    // eslint-disable-next-line
  }, [dispatch,successPay, successDeliver, successApprove, successCancel, refId]);

  useEffect(() => {
    if (success && initialLoading) {
      setInitialLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch, success]);

 /* useEffect(() => {
    if (refId) {
      dispatch(payOrder(orderId));
    }
    // eslint-disable-next-line
  }, [refId]);  */

  /* const successPaymentHandler = (paymentResult) => {
    dispatch(payOrder(orderId, paymentResult));
  }; */

  
  const approveHandler = () => {
    dispatch(approveOrder(order._id));
  };
  const cancelHandler = () => {
    dispatch(cancelOrder(order._id));
  };
  const payHandler = () => {
    dispatch(payOrder(order._id));
  };  
  
  const deliverHandler = () => {
    dispatch(deliverOrder(order._id));
  };

 /* const payWithEsewa = () => {
    var resultId = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < 14; i++) {
      resultId += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    var path = config.esewaPaymentUrl;
    var params = {
      amt: order.itemsPrice,
      psc: order.shippingPrice,
      pdc: 0,
      txAmt: order.taxPrice,
      tAmt: order.totalPrice,
      pid: resultId,
      scd: 'EPAYTEST',
      su: `http://localhost:3000/order/${orderId}`,
      fu: `http://localhost:3000/order/${orderId}`,
    };
    var form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', path);

    Object.keys(params).forEach((key) => {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });

    document.body.appendChild(form);
    form.submit();
  }; */

  return loading ? (
    <OrderLoader />
  ) : error ? (
    <ErrorMessage header="Something went wrong" message={error} />
  ) : (
    <>
      {order  ? (
        <>
          <h1>Order Placed Successfully</h1>
          <Row>
            <Col md={8}>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <h2>Shipping</h2>
                  <p>
                    <strong>Name: </strong> {order.userId.name}
                  </p>
                  <p>
                    <strong>Phone Number: </strong> {order.userId.mobile}
                  </p>
                  <p>
                    <strong>Email: </strong> <a href={`mailto:${order.userId.email}`}>{order.userId.email}</a>
                  </p>
                  <p>
                  <strong>Address: </strong>
                  {order.shipping.area}, {order.shipping.road}, {order.shipping.landmark},{order.shipping.building},{order.shipping.floorNo}, {order.shipping.houseNo}
                    
                  </p>
                  {order.isDelivered ? (
                    <Message variant="success">Delivered on {order.deliveredAt}</Message>
                  ) : (
                    <Message variant="danger">Not Delivered</Message>
                  )}
                </ListGroup.Item>

                <ListGroup.Item>
                  {order.isPaid ? (
                    <Message variant="success">Paid {order.paidAt}</Message>
                  ) : (
                    <Message variant="danger">Not Paid</Message>
                  )}
                </ListGroup.Item>

                <ListGroup.Item>
                  {order.isApproved ? (
                    <Message variant="success"> Your Order has been received and will be ready soon. Please pay upon delivery. Thank you :) {order.approvedAt}</Message>
                  ) : (
                    <Message variant="danger"></Message>
                  )}
                </ListGroup.Item>

                <ListGroup.Item>
                  {order.isCancelled ? (
                    <Message variant="success">Your Order has been cancelled </Message>
                  ) : (
                    <Message variant="danger"></Message>
                  )}
                </ListGroup.Item>

                {order.orderItems ? (
                  <ListGroup.Item>
                    <h2>Order Items</h2>
                    {!order.orderItems.length ? (
                      <Message>Order is empty</Message>
                    ) : (
                      <ListGroup variant="flush">
                        {order.orderItems.map((item, index) => (
                          <ListGroup.Item key={index}>
                            <Row>
                              <Col md={1}>
                                <Image src={item.productImage} alt={item.productName} fluid rounded />
                              </Col>
                              <Col>
                                <Link
                                  to={interpolate(routes.PRODUCT, {
                                    productId: item.productId,
                                  })}
                                >
                                  {item.productName}
                                </Link>
                              </Col>
                              <Col md={4}>
                                {item.qty} x Ksh{item.price} = Ksh{item.qty * item.price}
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        ))}

                     {order.orderItems.map((item, index) => (
                          <ListGroup.Item key={index}>
                            <Row>
                             
                              <Col>
                                <Link
                                  to={interpolate(routes.PRODUCT, {
                                    shippingId: item.shippingId,
                                  })}
                                >
                                  {item.area}
                                </Link>
                              </Col>
                              
                            </Row>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    )}
                  </ListGroup.Item>
                ) : (
                  ''
                )}
              </ListGroup>
            </Col>
            <Col md={4}>
              <Card>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <h2>Order Summary</h2>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>Items</Col>
                      <Col>Ksh{order.itemsPrice}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>Shipping</Col>
                      <Col>Ksh{order.shippingPrice}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>Tax</Col>
                      <Col>Ksh{order.taxPrice}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>Total</Col>
                      <Col>Ksh{order.totalPrice}</Col>
                    </Row>
                  </ListGroup.Item>

                  {loadingApprove && <Loader />}
                  {userInfo && userInfo.role === 'admin'  && !order.isApproved && !order.isCancelled && (
                    <ListGroup.Item>
                      <Button type="submit" variant="contained" color="primary" fullWidth onClick={approveHandler}>
                        Approve
                      </Button>
                    </ListGroup.Item>
                  )}

                  {loadingCancel && <Loader />}
                  {userInfo && userInfo.role === 'admin'  && !order.isCancelled && !order.isApproved && !order.isPaid && !order.isDelivered && (
                    <ListGroup.Item>
                      <Button type="submit" variant="contained" color="primary" fullWidth onClick={cancelHandler}>
                        Cancel
                      </Button>
                    </ListGroup.Item>
                  )}
    
                  {userInfo && userInfo.role === 'user'  && !order.isCancelled && !order.isApproved && !order.isPaid && !order.isDelivered && (
                    <ListGroup.Item>
                      <Button type="submit" variant="contained" color="primary" fullWidth onClick={cancelHandler}>
                        Cancel
                      </Button>
                    </ListGroup.Item>
                  )}

                  {loadingPay && <Loader />}
                  {userInfo && userInfo.role === 'admin'  && !order.isPaid && (
                    <ListGroup.Item>
                      <Button type="submit" variant="contained" color="primary" fullWidth onClick={payHandler}>
                        Mark As Paid
                      </Button>
                    </ListGroup.Item>
                  )}

                  {loadingDeliver && <Loader />}
                  {userInfo && userInfo.role === 'admin' && !order.isDelivered  && (
                    <ListGroup.Item>
                      <Button type="submit" variant="contained" color="primary" fullWidth onClick={deliverHandler}>
                        Mark As Delivered
                      </Button>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default Order;
